import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, ExpandableCheckboxGrid } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectAmenityFilter } from 'shared/selectors/advancedFilters';
import { EAmenityType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const AmenityContainer: FC = () => {
  const { label, value, options } = useSelector(selectAmenityFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (next: EAmenityType[]) => {
      onChange({
        action: 'setAmenity',
        arguments: [next.length > 0 ? (next as NonEmptyArray<EAmenityType>) : null],
      });
    },
    [onChange],
  );

  const cleanValue = value.filter((v): v is EAmenityType => v !== null);

  return (
    <AdvancedFilterRow label={label}>
      <ExpandableCheckboxGrid alwaysExpanded options={options} value={cleanValue} onChange={handleChange} />
    </AdvancedFilterRow>
  );
};
